
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PesquisaAulaExperimental from "./forms/PesquisaAulaExperimental";
import PesquisaNaoMatriculados from "./forms/PesquisaNaoMatriculados";
import './App.css';
import PesquisaNaoRenovacao from "./forms/PesquisaNaoRenovacao";
import PesquisaAlunosMatriculados from "./forms/PesquisaAlunosMatriculados";

const Home = () => <h1>Bem-vindo à Pesquisa de Satisfação</h1>;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aula-experimental" element={<PesquisaAulaExperimental />} />
        <Route path="/aula-experimental-nm" element={<PesquisaNaoMatriculados />} />
        <Route path="/renovacao" element={<PesquisaNaoRenovacao />} />
        <Route path="/alunos" element={<PesquisaAlunosMatriculados />} />
      </Routes>
    </Router>
  );
};

export default App;